



import { Prop, Component, Vue } from "vue-property-decorator";
@Component({ name: "default-title" })
export default class DefaultTitleComponent extends Vue {}



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/layouts/default/default-title.vue